import { GREY_CHATEAU, SECONDARY_THEME_COLOR } from "../../consts/colors";

export const styles={
checkBoxStyle:{
    span: {
      "&.Mui-checked": {
        color: SECONDARY_THEME_COLOR,
    },
    '&.Mui-disabled': {
      color:GREY_CHATEAU,
    },
    color:SECONDARY_THEME_COLOR,
    },

  },
  labelStyle:{
    fontSize: "14px",
    color: SECONDARY_THEME_COLOR,
    lineHeight:"20px",
    fontWeight:"500"
  }
}